module.exports = __webpack_public_path__ + "static/media/flower3.45a44b5a.png";